import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22arcadeFont.ts%22,%22import%22:%22%22,%22arguments%22:[{%22display%22:%22swap%22,%22fallback%22:[%22'Courier%20New'%22,%22monospace%22],%22src%22:%22./fonts/PressStart2P-Regular.woff2%22,%22variable%22:%22--font-arcade%22}],%22variableName%22:%22arcadeFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'arcadeFont', 'arcadeFont Fallback', 'Courier New', monospace",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
